import { ESeancesListMode } from "./ESeancesListMode";

export const EBoutonIconFiltreSeancesListMode: Record<ESeancesListMode, string> = {
    [ESeancesListMode.DETAILED]: 'article',
    [ESeancesListMode.COMPACT]: 'list'
};